export default __webpack_public_path__ + "static/media/404.fdc5a3b5.svg";